// components/Card.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import { Card, Typography, Box } from '@mui/material';

function CardComponent({ title, text, courseId }) {
    return (
        <Card
            component={Link}
            to={`/courses/${courseId}`}
            sx={{
                textDecoration: 'none',
                p: 3,
                minHeight: 210,
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
            }}
        >
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                <Box
                    sx={{
                        width: 52,
                        height: 52,
                        borderRadius: 2,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: 'primary.main',
                        bgcolor: 'rgba(79, 70, 229, 0.08)',
                        mb: 2,
                        fontWeight: 800,
                    }}
                >
                    {title?.slice(0, 2)?.toUpperCase()}
                </Box>
                <Typography variant="h5" component="h3" sx={{ mb: 0.5 }}>
                    {title}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                    {text}
                </Typography>
            </Box>
            <Typography sx={{ mt: 3, color: 'primary.main', fontWeight: 600 }}>
                Open lab
            </Typography>
        </Card>
    );
}

export default CardComponent;
